import Component from '../inherited/Component'

export default class ResetProductForm extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._form = this._elem.querySelector('form[data-type="add-to-cart-form"]')
    this._personalisationCheckbox = this._elem.querySelector('[data-personalisation-checkbox]')
    this._giftCheckboxContainer = this._elem.querySelector('[data-gift-checkbox-container]')
    this._variantSelects = this._elem.querySelector('variant-selects')
  }

  mount () {
    this._ctx.on('cart-item-added', e => {
      console.log("RESET")

      if (this._personalisationCheckbox) {
        if (this._personalisationCheckbox.checked) {
          this._personalisationCheckbox.click()
        }
      }

      if (this._giftCheckboxContainer) {
        if (this._giftCheckboxContainer.classList.contains('selected')) {
          this._giftCheckboxContainer.click()
        }
      }

      if (this._form) {
        this._form.reset()
      }

      if (this._variantSelects) {
        this._variantSelects.dispatchEvent(new Event('change'))
      }
    })
 
    if (this._personalisationCheckbox) {
      this._personalisationCheckbox.addEventListener('change', () => {
        if (!this._personalisationCheckbox.checked) {
          let personalisationSelects = this._personalisationCheckbox.closest('.product_personalisation').querySelectorAll('select')

          for (let select of personalisationSelects) {
            select.selectedIndex = 0
          }
        }
      })
    }
  }
}